import type { Database } from "@excel-center/supabase";
import { z } from "zod";

type DBResumeDocumentType = Database["public"]["Enums"]["resume_document_type"];

export const ResumeDocumentType = {
	RESUME: "resume",
	COVER_LETTER: "cover_letter",
	REFERENCE: "reference",
	COLLEGE_ACCEPTANCE_LETTER: "college_acceptance_letter",
	PROOF_OF_EMPLOYMENT: "proof_of_employment",
	PROOF_OF_CERTIFICATION: "proof_of_certification",
	TN_PROMISE: "tn_promise",
	TN_RECONNECT: "tn_reconnect",
	SCHOLARSHIP_OFFER: "scholarship_offer",
	OTHER: "other",
} as const satisfies Record<string, DBResumeDocumentType>;

export type ResumeDocumentType = (typeof ResumeDocumentType)[keyof typeof ResumeDocumentType];

type _EnsureAllDBValues = Exclude<DBResumeDocumentType, ResumeDocumentType> extends never ? true : never;
const _check: _EnsureAllDBValues = true;
void _check;

export const RESUME_DOCUMENT_TYPES = Object.values(ResumeDocumentType) as readonly ResumeDocumentType[];

export const RESUME_DOCUMENT_TYPE_LABELS: Record<ResumeDocumentType, string> = {
	resume: "Resume",
	cover_letter: "Cover Letter",
	reference: "Reference",
	college_acceptance_letter: "College Acceptance Letter",
	proof_of_employment: "Proof of Employment",
	proof_of_certification: "Proof of Certification",
	tn_promise: "TN Promise",
	tn_reconnect: "TN Reconnect",
	scholarship_offer: "Scholarship Offer",
	other: "Other",
};

export const resumeDocumentTypeSchema = z.enum(ResumeDocumentType);
